import React, { useState, useRef, useEffect } from 'react';
import CommonInput from '../Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import Locator from '../../images/icons/map_locator.jpg';
import { GoogleApiWrapper } from 'google-maps-react';
import './GoogleMap.css';
import Geocode from 'react-geocode';
import { GoogleMapKey } from '../../../data/SiteConfig';
import RadioButton from '../Dashboard-res/CommonComponent/RadioButton';
import Loader from '../../images/icons/loading2.svg';
import Loading from '../../common/components/CircularLoading/CircularLoading';
import PopUp from '../../common/components/PopUp/PopUp';
import { getApplicantPropertAddress } from '../../common/constants/api';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import * as _ from 'lodash';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';

Geocode.setApiKey(GoogleMapKey);
let autocomplete;
// set response language. Defaults to english.
Geocode.setLanguage('en');

// set response country. Defaults to english.
Geocode.setRegion('IN');

export const LoadingContainer = () => {
  const [show, setShow] = useState(true);
  return (
    <PopUp type={'loading'} text={'Loading...'} setShow={setShow} show={show} />
  );
};
const SimpleMap = props => {
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  } = useFormikContext();

  const [loading, setLoading] = useState(true);
  const [MapLoaded, setMapLoaded] = useState(false);
  const textInput = useRef(null);
  const markerRef = useRef(null);
  const MapRef = useRef(null);
  const MapLoadedRef = useRef(null);
  const GoogleMainCard = useRef(null);
  let marker, map;
  const [popUpText, setPopUpText] = useState('Loading');
  const [popUpType, setPopUpType] = useState('loading');
  const [show, setShow] = useState(true);

  // get current location

  useEffect(() => {
    setShow(true);
    getApplicantPropertAddress(getApplicantionInfo().leadId)
      .then(async response => {
        if (response) {
          let lattitude, longitude;
          lattitude = _.get(response, 'coordinates.latitude', false);
          longitude = _.get(response, 'coordinates.longitude', false);
          if (lattitude && longitude) {
            await initAutocomplete(
              response.coordinates.latitude,
              response.coordinates.longitude
            );
            setFieldValue(
              'house_address',
              `${_.get(response, 'address.line1', '') +
                ', ' +
                _.get(response, 'address.line2 ', '') +
                ', ' +
                _.get(response, 'address.city ', '') +
                ', ' +
                _.get(response, 'address.state', ' ') +
                ', ' +
                'India'}`
            );
            setFieldValue('pin_code', _.get(response, 'address.pinCode', ' '));
            setFieldValue('lat', _.get(response, 'coordinates.latitude', ' '));
            setFieldValue('lng', _.get(response, 'coordinates.longitude', ' '));
            setFieldValue('city', _.get(response, 'address.city', ' '));
            setFieldValue('state', _.get(response, 'address.state', ' '));
            setFieldValue(
              'savedKhataId',
              _.get(response, 'propertyTitleId', false)
            );
          } else {
            getLocation();
          }
        }
        setShow(false);
      })
      .catch(error => {});
  }, []);
  const getLocation = () => {
    setLoading(false);
    navigator.permissions.query({ name: 'geolocation' });
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then(function(result) {
          if (result.state == 'granted') {
            try {
              navigator.geolocation.getCurrentPosition(setPosition);
            } catch {}
          } else {
            initAutocomplete(12.9716, 77.5946);
          }
        });
    } else {
      try {
        initAutocomplete(12.9716, 77.5946);
      } catch {}
    }
  };

  // init the google map
  const setPosition = position => {
    let lng = position.coords.longitude ? position.coords.longitude : 77.5946;
    let lat = position.coords.latitude ? position.coords.latitude : 12.9716;
    initAutocomplete(lat, lng);
  };

  // get the full address from lat & lng
  const GettingAddress = (lat, lng) => {
    let full_address;

    // getting address details
    Geocode.fromLatLng(lat, lng).then(response => {
      // contains full address in array
      full_address = response.results[0].address_components;
      setAddress(
        full_address,
        response.results[0].formatted_address,
        response.results[0].name
      );
      setLngLat(lat, lng);
    });
  };

  // set the address in the in the input box
  const setAddress = (full_address, formated_address, name) => {
    if (full_address) {
      let house_address = '',
        iterator_value,
        pin_code = '';
      for (let i = 0; i < full_address.length; i++) {
        iterator_value = full_address[i].long_name;

        if (full_address[i].types[0] == 'administrative_area_level_2') {
          setFieldValue('city', iterator_value);
        }
        if (full_address[i].types[0] == 'administrative_area_level_1') {
          setFieldValue('state', iterator_value);
        }
        if (full_address[i].types[0] == 'country') {
          setFieldValue('country', iterator_value);
        }
        if (full_address[i].types[0] == 'postal_code') {
          setFieldValue('pin_code', iterator_value);
          pin_code = iterator_value;
        }
      }
      map.setZoom(17);
      house_address =
        (name ? name + ', ' : '') +
        formated_address
          .toString()
          .replace(pin_code + ',', '')
          .replace(pin_code, '');
      setFieldValue('house_address', house_address)
        .then(res => {
          try {
            auto_grow();
          } catch {}
        })
        .catch(err => {});

      GoogleMainCard.current.style.display = 'block';
    }
  };

  // get address from auto complete
  function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();

    setMarker(place.geometry.location.lat(), place.geometry.location.lng());
    setAddress(place.address_components, place.formatted_address, place.name);
    setLngLat(place.geometry.location.lat(), place.geometry.location.lng());
  }

  // set the marker on google map when address changed
  const setMarker = (lat, lng) => {
    var latlng = new google.maps.LatLng(lat, lng);
    marker.setPosition(latlng);
    map.panTo({ lat: lat, lng: lng });
  };

  // google Map container
  function initAutocomplete(lat, lng) {
    // setShow(true);
    map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: lat, lng: lng },
      zoom: 13,
      mapTypeId: 'roadmap'
    });
    var clickHandler = new ClickEventHandler(map, { lat: lat, lng: lng });
    GettingAddress(lat, lng);

    // autocomplete initialiser
    autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      {
        componentRestrictions: {
          country: 'IN'
        }
      }
    );
    autocomplete.addListener('place_changed', fillInAddress);
    google.maps.event.addListenerOnce(map, 'idle', function() {
      setMapLoaded(true);
      MapLoadedRef.current.style.display = 'flex';
    });
    marker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: map,
      title: 'your property location'
    });
    // setShow(false);
  }
  var ClickEventHandler = function(map, origin) {
    this.origin = origin;
    this.map = map;
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();
    this.directionsRenderer.setMap(map);
    this.placesService = new google.maps.places.PlacesService(map);

    // Listen for clicks on the map.
    this.map.addListener('click', this.handleClick.bind(this));
  };

  ClickEventHandler.prototype.handleClick = function(event) {
    if (event.placeId) {
      event.stop();
      this.getPlaceInformation(event.placeId);
    } else {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          latLng: event.latLng
        },
        function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              let addess = results[0].address_components;
              let formated_address = results[0].formatted_address;
              setMarker(event.latLng.lat(), event.latLng.lng(), marker);
              setAddress(addess, formated_address, results[0].name);
              setLngLat(event.latLng.lat(), event.latLng.lng());
            }
          }
        }
      );
    }
  };

  ClickEventHandler.prototype.getPlaceInformation = function(placeId) {
    this.placesService.getDetails({ placeId: placeId }, function(
      place,
      status
    ) {
      if (status === 'OK') {
        setMarker(
          place.geometry.location.lat(),
          place.geometry.location.lng(),
          marker
        );
        setAddress(
          place.address_components,
          place.formatted_address,
          place.name
        );
        setLngLat(place.geometry.location.lat(), place.geometry.location.lng());
      }
    });
  };

  const geolocate = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        var circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy
        });
        autocomplete.setBounds(circle.getBounds());
      });
    }
  };

  const auto_grow = () => {
    textInput.current.style.height = '0px';
    textInput.current.style.height = textInput.current.scrollHeight
      ? textInput.current.scrollHeight + 'px'
      : '80px';
  };

  const setLngLat = (lat, lng) => {
    setFieldValue('lat', lat);
    setFieldValue('lng', lng);
  };

  useEffect(() => {
    setFieldValue('property_identified', true),
      setFieldValue('property_not_identified', false),
      (MapRef.current.style.display = 'block');
  }, []);
  return (
    <>
      <PopUp type={popUpType} text={popUpText} setShow={setShow} show={show} />

      <div ref={GoogleMainCard} style={{ display: 'none' }} className="">
        <input
          type="text"
          name="lat"
          className="hidden"
          value={values.lat}
          readOnly
        />
        <input
          type="text"
          name="lng"
          className="hidden"
          value={values.lng}
          readOnly
        />
        <input
          type="text"
          name="city"
          className="hidden"
          value={values.city}
          readOnly
        />
        <input
          type="text"
          name="state"
          className="hidden"
          value={values.state}
          readOnly
        />

        <div className="w-full bg-white map_container h-full min-h-screen ">
          <div
            className={`w-full md:w-12/12 lg:w-12/12 xl:w-12/12 py-10 md:py-0 ${
              values.notshowBorder ? 'md:my-10' : 'md:my-32'
            }  mx-auto `}
          >
            <div
              className={`w-full md:w-10/12 ${
                values.notshowBorder
                  ? ' '
                  : ' lg:w-8/12 md:shadow-2xl md:border-2 md:border-grey-1100'
              } mx-auto  md:px-4  md:rounded-lg bg-white block`}
            >
              <div className="">
                <div className="w-11/12 md:w-11/12 mr-auto text-base font-roboto font-normal text-black-0 ">
                  <p className="my-3 text-lg font-roboto font-semibold text-black-400 mb-3">
                    Property Address
                  </p>
                </div>
              </div>

              <div className="hidden " ref={MapRef}>
                <div
                  id="locationField"
                  className="w-10/12 md:w-8/12 mr-auto mt-3 mb-5"
                >
                  <input
                    id="autocomplete"
                    className=" py-3 border border-grey-350 px-4   fieldset_box  h-full w-full rounded-sm md:rounded bg-white  
              hover:border hover:border-green-600 border border-grey-350"
                    placeholder="Search for your Property Address "
                    onFocus={() => geolocate}
                    type="text"
                  />
                </div>

                <div className="w-full  md:flex">
                  <div
                    className="w-full  hidden py-3 md:border md:border-grey-500"
                    ref={MapLoadedRef}
                  >
                    <div className="w-full block  md:flex ">
                      <div
                        className="w-full md:w-6/12 px-4 my-4 relative  md:ml-0"
                        style={{ height: '19rem' }}
                      >
                        <div
                          id="map"
                          className="w-11/12 md:w-full h-19rem mx-auto"
                          style={{ height: '19rem', width: '100%' }}
                        ></div>
                      </div>
                      <div className="w-full md:w-6/12 mt-10 md:mt-0 ">
                        <div className=" md:block w-11/12 md:w-10/12 mx-auto block mb-6 "></div>
                        <div className="w-10/12 mx-auto mt-7 ">
                          <div className="my-10 ">
                            <div className="my-10  flex i">
                              <div className="grid_input_container relative mb-4 w-full">
                                <div>
                                  <fieldset
                                    className={
                                      errors.house_address
                                        ? 'w-full py-3 border border-red-100 px-4   fieldset_box  h-full w-full rounded-sm md:rounded bg-white  hover:border hover:border-red-100 items-center '
                                        : 'w-full py-3 border border-grey-350 px-4   fieldset_box  h-full w-full rounded-sm md:rounded bg-white'
                                    }
                                  >
                                    <div className="-mt-6   font-roboto text-black-600 font-nomal">
                                      <span
                                        className={
                                          errors.house_address
                                            ? 'bg-white text-red-100'
                                            : 'bg-white text-red-black-600'
                                        }
                                      >
                                        House Address
                                      </span>
                                    </div>
                                    <div className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md  items-center">
                                      <img
                                        src={Locator}
                                        ref={markerRef}
                                        className="w-6 "
                                        alt="my locator"
                                        // style={{ width: 'auto', maxHeight: '50px' }}
                                      />
                                    </div>

                                    <textarea
                                      ref={textInput}
                                      name="house_address"
                                      style={{
                                        height: '0px',
                                        backgroundColor: 'white'
                                      }}
                                      id="house_address"
                                      onChange={event => {
                                        setFieldValue(
                                          'house_address',
                                          event.target.value
                                        ),
                                          auto_grow();
                                      }}
                                      disabled={false}
                                      onBlur={handleBlur}
                                      className="w-10/12 mx-auto  ml-9 "
                                      value={values.house_address}
                                    />
                                  </fieldset>
                                  {errors.house_address ? (
                                    <div className="w-full">
                                      <p className="text-red-100 font-roboto text-sm">
                                        {' '}
                                        {errors.house_address}
                                      </p>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="my-10 md:my-10">
                              <CommonInput
                                name="pin_code"
                                id="pin_code"
                                disabled={false}
                                onBlur={handleBlur}
                                onChange={event => {
                                  !isNaN(event.target.value) &&
                                  event.target.value.length <= 6
                                    ? setFieldValue(
                                        'pin_code',
                                        event.target.value
                                      )
                                    : null;
                                }}
                                value={values.pin_code}
                                stylesContainer={{
                                  height: '52px',
                                  maxWidth: '100%'
                                }}
                                legendName="Pin-Code"
                                error={touched.pin_code && errors.pin_code}
                                errorMsg={errors.pin_code}
                                touched={touched.pin_code}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {!MapLoaded ? (
                    <img className="w-10 py-48 mx-auto " src={Loader} />
                  ) : null}
                </div>
              </div>
            </div>

            <button
              className=" submitButton w-56 lg:w-80 "
              type="submit"
              id="submit"
              onClick={handleSubmit}
              disabled={
                values.property_not_identified
                  ? false
                  : errors.house_address ||
                    errors.pin_code ||
                    values.house_address == '' ||
                    values.pin_code == '' ||
                    (values.property_identified == false &&
                      values.property_not_identified == false) ||
                    isSubmitting
              }
            >
              NEXT
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withErrorHandler(
  GoogleApiWrapper({
    apiKey: GoogleMapKey,
    LoadingContainer: LoadingContainer
  })(SimpleMap)
);
